import { HStack, Image, Text } from '@chakra-ui/react'
import { FacebookShareButton as ShareButton } from 'react-share'

function FacebookShareButton(): React.ReactElement {
  const url = global.window && window.location.href

  return (
    <ShareButton url={url}>
      <HStack
        sx={{
          bg: '#1877f2',
          borderRadius: '4px',
          color: 'white',
          fontSize: '13px',
          height: '28px',
          p: '0 8px',
        }}
      >
        <Image src={'/images/blogs/fb-share.png'} sx={{ boxSize: '16px' }} />
        <Text sx={{ lineHeight: 1, fontWeight: 400 }}>Share</Text>
      </HStack>
    </ShareButton>
  )
}

export default FacebookShareButton
